import type { TopMovieSearchParams } from 'src/models';
import type { GIComment, GIResource } from 'src/models/geoItem';
import type { IGeoItemSearchRef } from 'src/models/geoItemSearch';
import type { CarIndexParams } from 'src/models/apis/cars/carRequest';
import type { CommentIndexParams } from 'src/models/apis/comment/commentRequest';
import type { JunkaiTenkenIndexParams } from 'src/models/apis/extJunkaiTenkenReportTenkenData/extJunkaiTenkenReportTenkenDataRequest';
import type { DetectionsIndexParams } from 'src/models/apis/extLandAiDetections/extLandAiDetectionsRequest';
import type { EmergencyIndexParams } from 'src/models/apis/extLandApEmergency/extLandApEmergencyRequest';

export default abstract class GIAbstractManager {
  constructor() {
    if (this.constructor === GIAbstractManager) {
      throw new TypeError('Abstract class "GIAbstractManager" ' +
        'cannot be instantiated directly.');
    }
  }

  abstract getResources(componentRef: IGeoItemSearchRef<unknown>): Promise<GIResource[]>;

  abstract getResourcesByParams(params:
    CarIndexParams |
    CommentIndexParams |
    JunkaiTenkenIndexParams |
    EmergencyIndexParams |
    DetectionsIndexParams |
    TopMovieSearchParams): Promise<GIResource[]>;

  abstract getResourceById(id: number) : Promise<GIResource | null>;
  // 現在のresourcesから新しいresourcesに対して、
  // 画面上の状態関連のプロパティを引き継ぐ
  abstract mergeStateInfo(newResources: GIResource[], currentResources: GIResource[]): GIResource[];

  // 現状付箋のみ作成、更新、削除ができるが、今後拡張する可能性があるので親クラスで定義
  abstract createResource(params: GIComment): Promise<GIComment>;

  abstract updateResource(params: GIComment): Promise<GIComment>;

  abstract deleteResource(params: GIComment): Promise<GIComment>;

  filterTabPaneElements(data: GIResource[]): GIResource[] {
    return data;
  }
}
